import { useCallback, useMemo } from "react";
import isEqual from "lodash/isEqual";
import useSearchResult from "views/hooks/useSearchResult";
import useCurrentQuery from "views/logic/queries/useCurrentQuery";
import useIsLoading from "views/hooks/useIsLoading";
const useSearchResultTimeRangeErrorCheck = (errorType) => {
  var _a;
  const searchResult = useSearchResult();
  const currentQuery = useCurrentQuery();
  const isLoadingExecution = useIsLoading();
  const searchResultErrors = useMemo(
    () => {
      var _a2, _b, _c;
      return (_c = (_b = (_a2 = searchResult == null ? void 0 : searchResult.result) == null ? void 0 : _a2.errors) == null ? void 0 : _b.filter((error) => error.queryId === (currentQuery == null ? void 0 : currentQuery.id))) != null ? _c : [];
    },
    [currentQuery == null ? void 0 : currentQuery.id, (_a = searchResult == null ? void 0 : searchResult.result) == null ? void 0 : _a.errors]
  );
  const timeRangeHasErrorInResults = useMemo(
    () => searchResultErrors.some(({ type }) => type === errorType),
    [errorType, searchResultErrors]
  );
  return useCallback(
    (currentTimeRange) => {
      const executedTimerange = currentQuery == null ? void 0 : currentQuery.timerange;
      return !isLoadingExecution && isEqual(currentTimeRange, executedTimerange) && timeRangeHasErrorInResults;
    },
    [currentQuery == null ? void 0 : currentQuery.timerange, isLoadingExecution, timeRangeHasErrorInResults]
  );
};
export default useSearchResultTimeRangeErrorCheck;
